import TWEEN from '@tweenjs/tween.js';
import settings from './config/Settings';
import Camera from './Camera';
import Renderer from './Renderer';
import Controls from './Controls';
import Universe from './universe/Universe';

class Spacecast {
  constructor(canvasWidth, canvasHeight) {
    this.camera = new Camera();
    
    this.renderer = new Renderer(canvasWidth, canvasHeight);

    this.updateUiDistance = false;
    this.updateUiDistanceCallback = () => {};
  }

  init(){
    // try {
      this.universe = new Universe();
      this.controls = new Controls(this, settings);
      // Start with focus set on Earth.
      // this.controls.orbitControls.target = this.universe.planets.three.planets.find(planet => (planet.name === 'Earth')).mainObject.position;
      this.controls.orbitControls.target = this.universe.beam?.three?.beamGroup?.mainObject?.position || this.universe.planets.three.planets.find(planet => (planet.name === 'Earth')).mainObject.position;
    // }catch (e){}
  }

  update(currentTime, deltaTime) {
    if(!this.universe) return;
    TWEEN.update(currentTime);

    if (this.universe.visibleLabels) {
      this.universe.updateLabelScales(this.camera.getPosition());
      this.universe.sun.updateLabelPosition(this.camera.getPosition());
    }

    if (this.controls.animatePlanets) {
      this.universe.planets.rotatePlanets(deltaTime);
      this.universe.planets.translatePlanets(deltaTime);
    }

    this.universe.beam.pulseAnimation();
    this.controls.update();
    this.updateUi();
  }

  updateUi() {
    if(!this.universe) return;
    if (this.updateUiDistance) {
      const distance = Math.round(this.camera.distanceTo(this.controls.orbitControls.target));
      this.updateUiDistanceCallback(distance);
    }
  }

  getScene() {
    if(!this.universe) return null;
    return this.universe.three?.scene;
  }

  getSun() {
    if(!this.universe) return null;
    return this.universe.getSun()?.three?.sun;
  }

  getPlanets() {
    if(!this.universe) return null;
    return this.universe.getPlanets()?.three?.planets;
  }

  getNearStars() {
    if(!this.universe) return null;
    return this.universe.getNearstars()?.three?.nearStars;
  }

  getBeam() {
    if(!this.universe) return null;
    return this.universe.getBeam().three.beamGroup;
  }
}

export default Spacecast;